import React, { Component } from 'react';
import { Button, Col } from 'react-bootstrap';

import MapModal from '../MapModal';

/**
* Class MapFilter
* MapFilter view component
**/
class MapFilter extends Component {

  /**
  * constructor
  * Init state
  **/
  constructor(props) {
    super(props);

    this.state = {
      mapFrame: false,
      values: []
    };

    this.receiveMessage = this.receiveMessage.bind(this);
  }

  /**
  * componentWillMount
  * Init window event to get IFrame response
  **/
  componentDidMount() {
    addEventListener("message", this.receiveMessage);
  }

  /**
  * componentWillUnmount
  * Delete window event
  **/
  componentWillUnmount() {
    removeEventListener("message", this.receiveMessage);
  }

  /**
  * receiveMessage
  * Handle IFrame response
  **/
  receiveMessage(event) {
    this.handleMapCancel();

    if(event.data instanceof Array) {
      let arrId = [];

      event.data.forEach((item) => {
        if(arrId.indexOf(item.id) === -1) arrId.push(item.id);
      });

      this.setState({ values: arrId });

      this.props.parentFilter.handleChange(this, arrId);
    }

  }

  /**
  * render
  * Rendering component function : display the view
  **/
  render() {
    return (
      <Col componentClass="filterTextField" sm={2}>
        {this.getMapModal()}
        <Button bsStyle="primary" onClick={this.onSearchClick.bind(this)}>{this.state.values.length > 0 ? this.state.values.length + " entité(s) sélectionnée(s)" : "Rechercher dans la carte"}</Button>
        {this.state.values.length > 0 ?
          <Button bsStyle="danger" className="glyphicon glyphicon-remove" onClick={this.onClearClick.bind(this)} /> : null
        }
      </Col>
    );
	}

  /**
  * getMapModal
  * Returns the MapModal
  **/
  getMapModal() {
    const mapProps = {
      mapFrame: this.state.mapFrame,
      onHide: this.handleMapCancel.bind(this),
      queryLayers: this.props.layer,
      allowDraw: false,
      selectionMultiple: true,
      typeGeometry: "all"
    };

    return <MapModal {...mapProps} />;
  }

  /**
  * onSearchClick
  * Open the map modal
  **/
  onSearchClick() {
    this.setState({mapFrame: true});
  }

  /**
  * handleMapCancel
  * Handle cancel click
  **/
  handleMapCancel() {
    this.setState({mapFrame: false});
  }

  /**
  * onClearClick
  * Clear the filter
  **/
  onClearClick() {
    this.props.parentFilter.handleChange(this, "");
    this.setState({values: []});
  }

}
export default MapFilter;



// WEBPACK FOOTER //
// ./src/views/Helper/GridFilter/MapFilter.js